import React from "react";
import { Typography } from "@mui/material";

const LoginPromotionPanel = () => {
    return (
        <div
            style={{
                flex: 1,
                backgroundImage: `url(${process.env.REACT_APP_IMAGE_BASE_URL}/uploads/default/login-bg-3.jpg)`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                display: window.innerWidth >= 960 ? "block" : "none", // md 相当
            }}
        >
            {/*<div
                style={{
                    height: "100%",
                    background: "rgba(0, 0, 0, 0.4)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#fff",
                    flexDirection: "column",
                    textAlign: "center",
                    padding: 16,
                }}
            >
                <Typography variant="h4" style={{ marginBottom: 16, fontWeight: "bold" }}>
                    あなたの注文管理をもっと簡単に。
                </Typography>
                <Typography variant="h6">
                    高速・安心・使いやすい次世代オーダー管理システム
                </Typography>
            </div>*/}
        </div>
    );
};

export default LoginPromotionPanel;
